module.exports = __webpack_public_path__ + "static/media/redemption-gift-picnic-mat.9863331f.png";